import { useQuery, type UseQueryResult } from "@tanstack/react-query";
import { PREDICTIONS_QUERY_KEYS } from "@/features/predictions/constants/queryKeys";
import { matchesService } from "@/features/predictions/services/matches.service";
import type { Competition } from "@/features/predictions/types/competition.type";

const STALE_TIME_MS = 5 * 60 * 1000;

export const useActiveCompetition = (): UseQueryResult<Competition | null> => {
  return useQuery<Competition | null>({
    queryKey: PREDICTIONS_QUERY_KEYS.activeCompetition(),
    queryFn: () => matchesService.getActiveCompetition(),
    staleTime: STALE_TIME_MS,
  });
};
